import { useSelector } from "react-redux";

import traplinked_statuses from "../../data/traplinked_statuses.json";
import { RootState } from "../../store";
import { CustomButton } from "../CustomButton/CustomButton";

import styles from "./list.module.css";

type ListDataItem = {
  id: string;
  name: string;
  objectName?: string | null;
  address?: string | null;
  digitalMonitorStatus?: number;
  digitalMonitorStatusText?: string;
};

type ListProps = {
  title?: string | null;
  subtitle?: string | null;
  data: ListDataItem[] | [];
  onItemSelected?: any;
  hideShadow?: boolean;
  boldName?: boolean;
  onEditClick?: (item: ListDataItem) => void;
};

export const List = ({
  title,
  subtitle,
  data,
  onItemSelected,
  hideShadow = false,
  boldName = false,
  onEditClick
}: ListProps) => {
    const isAdmin = useSelector((state: RootState) =>
      state.user.roles.some(
        (role) => role === "admin" || role === "kunde.admin"
      )
    );
    
  return (
    <div className={`${styles.list} ${hideShadow ? styles["no-shadow"] : ""}`}>
      {title && <h1 className={styles["list__title"]}>{title}</h1>}
      {subtitle && <h3 className={styles["list__subtitle"]}>{subtitle}</h3>}

      <ul>
        {data?.map((item: ListDataItem, i) => {
          const monitorStatus = traplinked_statuses.find(
            (status) => status.status === item.digitalMonitorStatus
          );

          return (
            <div
              className={styles["list__card"]}
              key={i}
              onClick={() => onItemSelected?.(item)}
            >
              <div
                className={styles["list__card-content"]}
                style={{ width: "100%" }}
              >
                <div>
                  {item.objectName ? (
                    <span className={styles.list__item}>
                      <strong className={styles["list__item-bold"]}>
                        {item.objectName}
                      </strong>{" "}
                      <br />
                      {item.name}
                    </span>
                  ) : boldName ? (
                    <h2 className={styles.list__item}>{item.name}</h2>
                  ) : (
                    <span
                      className={`${styles.list__item} ${styles["list__item-normal"]}`}
                    >
                      {item.name}
                    </span>
                  )}

                  {item.address && (
                    <p className={styles["list__item-address"]}>
                      {item.address}
                    </p>
                  )}
                </div>

                <div className={styles["list__card-content"]}>
                  {isAdmin && <CustomButton
                    color="transparent"
                    icon="edit"
                    width={16}
                    onClick={(e) => {
                      e.stopPropagation();
                      onEditClick?.(item);
                    }}
                  />}

                  {monitorStatus && (
                    <span
                      className={styles["list__status-circle"]}
                      style={{ backgroundColor: monitorStatus.color }}
                      title={item.digitalMonitorStatusText}
                    />
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </ul>
    </div>
  );
};
